import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>
        <span
          id={styles["footer-copyright__logo"]}
        >
          &copy;
        </span>
        Copyright.All rights reserved.Created this
        from a template on olanding.com
      </p>
    </footer>
  );
};

export default Footer;
